import type { LeadActivity } from '../types';

export interface VisitDraft { date: string; notes: string }

export function visitDate(value?: string): string {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function newVisit(): VisitDraft {
  return { date: visitDate(new Date().toISOString()), notes: '' };
}

export function visitPayload(draft: VisitDraft, previous?: LeadActivity): Partial<LeadActivity> {
  const date = new Date(`${draft.date}T00:00:00`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(draft.date) || !Number.isFinite(date.getTime()) || visitDate(date.toISOString()) !== draft.date) {
    throw new Error('Selectează o dată validă pentru vizită.');
  }
  const previousStart = previous?.startAt ? new Date(previous.startAt) : undefined;
  const validPreviousStart = previousStart && Number.isFinite(previousStart.getTime());
  // Editing a historical record must not silently change its type, status or
  // time/duration just because the simplified form no longer exposes them.
  if (validPreviousStart) date.setHours(previousStart.getHours(), previousStart.getMinutes(), previousStart.getSeconds(), previousStart.getMilliseconds());
  const payload: Partial<LeadActivity> = {
    type: previous?.type || 'site_visit',
    status: previous?.status || 'completed',
    startAt: date.toISOString(),
    allDay: previous ? previous.allDay : true,
    notes: draft.notes,
    outcome: previous?.outcome,
  };
  if (validPreviousStart && previous?.endAt) {
    const end = new Date(previous.endAt);
    if (Number.isFinite(end.getTime())) payload.endAt = new Date(end.getTime() + date.getTime() - previousStart.getTime()).toISOString();
  }
  return payload;
}

export function activityHistory(items: LeadActivity[]): LeadActivity[] {
  const timestamp = (item: LeadActivity) => {
    const value = Date.parse(item.startAt || item.completedAt || '');
    return Number.isFinite(value) ? value : 0;
  };
  return [...items].sort((a, b) => timestamp(b) - timestamp(a));
}
